import store from "../store";
import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';
import consts from "@/consts.js";

async function fetch(data){
    let fieldFilter = [
        "id",
        "purchase_code",
        "created",
        "complete_date",
        "third_return",
        "Stock.name",
        "Supplier.supplier_name",
        "hope_delivery_date",
        "status",
        "logistics_json",
        "origin_flg",
        "check_flg",
        "delivery_flg",
        "supplier_id",
    ]; //仅筛选少许必要字段
    return Request("get","api/purchases/", Object.assign({}, data, {
        fieldFilter: fieldFilter,
    }))
}

async function fetchOne(id,data){
    return Request("get","api/purchases/" + id, data)

}

async function print(id){
    return Request("get","api/purchases/" + id)
}

async function batchPrint(data){
    data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
    return Request("get","api/purchases/index/PRE_PRINT" , data)
}

async function delivery(data){
    return Request("post","api/purchases/delivery/" ,data)
}

async function supplierEdit(id, data){
    return Request("post","api/purchases/supplier-edit/" + id, data)
}

async function check(id){
    return Request("post","api/purchases/check/" + id)
}

async function Exports(id) {
    store.dispatch("fullscreenLoading");
    const response = await Request("post","api/purchases/supplier-delivery-export/" + id)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function batchExports(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/purchases/delivery-batch-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/purchases/delivery-import", data);
}

async function editLogistic(id, data) {
    // 修改发货物流
    return Request("post","api/purchases/edit-logistics/" + id , data)
}

async function getLogistics(data) {
    // 获取供应商物流列表
    return Request("get","api/logistics" , data)
}

async function batchDelivery(data) {
  //批量发货
  return Request('get', 'api/purchases/batch-delivery', data, false, false, true)
}


export default {
    fetch,
    fetchOne,
    print,
    batchPrint,
    delivery,
    supplierEdit,
    check,
    Exports,
    batchExports,
    imports,
    editLogistic,
    getLogistics,
    batchDelivery,
}